import { BaseAPI } from "./BaseApi";

export class SteamAPI extends BaseAPI {
    constructor() {
        super(""); // you can pass REACT_APP_API_URL here if needed
    }

    async getSteamGames() {
        return this.request<{ games: any[] }>("/api/steam/getgames", { method: "GET", auth: true });
    }

    async getSteamUserGames(userId:string) {
        return this.request<{ games: any[] }>(`/api/steam/user/games?userId=${userId}`, { method: "GET", auth: true });
    }
}